import {displayModes} from '../../../../../../services/enums/displayModes';
import Columns from './columns';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const DefaultConfig = {
  [displayModes.admin]: {
    version: 1,
    columns: {}
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {
      stopNumber: {
        columnName: Columns.stopNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      streetAndNumber: {
        columnName: Columns.streetAndNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 2
      },
      boxAmount: {
        columnName: Columns.boxAmount.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 3
      },
      weight: {
        columnName: Columns.weight.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4
      },
      volume: {
        columnName: Columns.volume.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5
      },
      remove: {
        columnName: Columns.remove.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 6
      },
    }
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {}
  },
}

export default DefaultConfig;